import React, { useEffect, useRef } from "react";
import { Chart } from "chart.js";

const MyChartComponent = () => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (chartRef.current) {
      const ctx = chartRef.current.getContext("2d");
      new Chart(ctx, {
        type: "bar",
        data: {
          labels: ["1st Week", "2nd Week", "3rd Week", "4th Week"],
          datasets: [
            {
              label: "Stock Purchase",
              data: [10000, 20000, 15000, 15000],
              borderRadius: 5,
              hoverBorderColor: "black",
              borderWidth: 2,
              backgroundColor: ["#FF5050", "#FF5050", "#FF5050"],
            },
            {
              label: "Broker Fee",
              data: [15000, 25000, 18000, 15000],
              borderRadius: 5,
              borderWidth: 2,
              hoverBorderColor: "black",
              backgroundColor: ["#F77E27", "#F77E27", "#F77E27"],
            },
            {
              label: "Stock",
              data: [10000, 20000, 15000, 15000],
              borderRadius: 5,
              borderWidth: 2,
              hoverBorderColor: "black",
              backgroundColor: ["#FFC421", "#FFC421", "#FFC421"],
            },
            {
              label: "Stock Purchase",
              data: [10000, 20000, 15000, 12000],
              borderRadius: 5,
              borderWidth: 2,
              hoverBorderColor: "black",
              backgroundColor: ["#34C046", "#34C046", "#34C046"],
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
              position: "top",
              labels: {
                boxWidth: 12,
                font: {
                  size: 10,
                },
                color: "black",
              },
            },
            tooltip: {
              enabled: true,
              backgroundColor: "black",
              borderColor: "black",
              borderWidth: 1,
              bodyColor: "white",
              position: "average",
              displayColors: false,
              callbacks: {
                title: (tooltipItems) => tooltipItems[0].dataset.label,
                label: (tooltipItem) => `$${tooltipItem.raw.toFixed(2)}`,
              },
              titleColor: (tooltipItems) => {
                if (tooltipItems.tooltipItems.length > 0) {
                  const datasetIndex = tooltipItems.tooltipItems[0].datasetIndex;
                  const backgroundColor =
                    tooltipItems.tooltipItems[0].chart.data.datasets[datasetIndex]
                      .backgroundColor[0];
                  return backgroundColor || "#8DAAE8";
                }
                return "#8DAAE8";
              },
              padding: 10,
            },
          },
          scales: {
            x: {
              ticks: {
                font: {
                  size: 10,
                },
                color: "black", // Set X-axis label color to black
                display: true,
              },
            },
            y: {
              ticks: {
                font: {
                  size: 10,
                },
              },
            },
          },
        },
      });
    }
    
  }, []); // Run only once when the component mounts

  return (
    <div className="relative h-48 w-full">
      <canvas ref={chartRef} />
    </div>
  );
};

export default MyChartComponent;
